import GoogleAuthenticator from '../GoogleAnalytics';
import { FacebookButton } from '../../../TopLevel/Components/Authorisation/FacebookButton';
import { TwitterButton } from '../../../TopLevel/Components/Authorisation/TwitterButton';
import GoogleButton from '@navigation/screens/TopLevel/Components/Authorisation/GoogleButton';

const scopes = ['https://www.googleapis.com/auth/analytics.readonly']
const socialList = [
  {
    value: 'twitter',
    icon: require('../../../../../../assets/animations/69061-twitter-subtle.json'),
    header: 'twitterAnalytics',
    // component:<TwitterButton />,
    description: 'twitterDescription',
  },
  {
    value: 'instagram',
    icon: require('../../../../../../assets/animations/69057-instagram.json'),
    header: 'instagramAnalytics',
    component: null,
    description: 'instagramDescription',
  },
  {
    value: 'facebook',
    icon: require('../../../../../../assets/animations/69034-facebook.json'),
    header: 'facebookAnalytics',
    // component: <FacebookButton />,
    description: 'facebookDescription',
  },
  {
    value: 'linkedin',
    icon: require('../../../../../../assets/animations/69066-linkedin-subtle.json'),
    header: 'linkedInAnalytics',
    component: null,
    description: 'linkedInDescription',
  },
  {
    value: 'tiktok',
    icon: require('../../../../../../assets/animations/49416-tiktok-icon.json'),
    header: 'tiktokAnalytics',
    component: null,
    description: 'tiktokDescription',
  },
  {
    value: 'website',
    icon: require('../../../../../../assets/animations/website.json'),
    header: 'analyticsHeader',
    component: <GoogleButton scopes={scopes} />,
    description: 'analyticsDescription',
  },
];

export default socialList;